import { Leaf } from 'lucide-react';

// Klymart logo — stylised "K" with a lime leaf inside, matching the brand identity
export default function KlymartLogo({ size = 32, className = '' }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-lg ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox="0 0 32 32" width={size} height={size} fill="none">
        <rect width="32" height="32" rx="8" fill="hsl(var(--secondary))" stroke="hsl(var(--border))" />
        {/* K stem */}
        <rect x="7" y="6" width="3.4" height="20" rx="1.4" fill="hsl(var(--primary))" />
        {/* leaf inside K */}
        <path
          d="M11.6 16c0-4.6 3.2-8 8.4-8.6 0.4 5.4-3 9-8.4 8.6z"
          fill="hsl(var(--primary))"
          opacity="0.9"
        />
        <path
          d="M11.6 16c2-3.2 5-5.6 8.4-7.4"
          stroke="hsl(var(--background))"
          strokeWidth="1"
          strokeLinecap="round"
        />
        {/* lower leg of K (lime accent) */}
        <path
          d="M11 18 L20 26"
          stroke="hsl(var(--primary))"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <Leaf className="sr-only" />
    </span>
  );
}
